/**
 * Manual Device Constants
 *
 * The BFF emits each device's mode dropdown as an action-component state whose
 * `stateName` is this prefix followed by the device alias (see `CreateModeDropdown`
 * in `bff/domains/shared/action-components/action-components.go`).
 */

/** State-name prefix of the mode dropdown action state. */
export const MODE_DROPDOWN_STATE_PREFIX = 'mode-dropdown-';

/** A device is in a manual mode when its current mode label starts with this (case-insensitive). */
export const MANUAL_MODE_PREFIX = 'Manual';
